module.exports = __webpack_public_path__ + "img/Inform Graphic 2.9f3c96a9.png";